import React from 'react';
import './Contact.css';
import WhatsAppIcon from '../../assets/WhatsApp.webp';
import InstagramIcon from '../../assets/Instagram.webp';
import locationIcon from '../../assets/location.png';
import phoneIcon from '../../assets/phone.png';
import mailIcon from '../../assets/mail.png';

const Contact = () => {
  const handleContactClick = (type, value) => {
    if (type === 'email') {
      window.location.href = `mailto:${value}`;
    } else if (type === 'phone') {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const phoneNumber = value.replace(/\D/g, ''); // Remove caracteres não numéricos
      
      if (isMobile) {
        window.location.href = `tel:+55${phoneNumber}`;
      } else {
        // No desktop, abre WhatsApp
        window.open(`https://wa.me/55${phoneNumber}`, '_blank');
      }
    } else if (type === 'address') {
      const address = encodeURIComponent(value);
      window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, '_blank');
    }
  };

  const contactInfo = [
    {
      icon: locationIcon,
      title: 'Endereço',
      details: ['Rua Eliseu Jose Hipolito, 1705', 'Centro', 'Piraquara - PR'],
      isImage: true,
      type: 'address',
      value: 'Rua Eliseu Jose Hipolito, Centro, Piraquara - PR'
    },
    {
      icon: phoneIcon,
      title: 'Telefone',
      details: ['(41) 99833-0446'],
      isImage: true,
      type: 'phone',
      value: '(41) 99833-0446'
    },
    {
      icon: mailIcon,
      title: 'E-mail',
      details: ['contato@primeats.com.br'],
      isImage: true,
      type: 'email',
      value: 'contato@primeats.com.br'
    }
  ];

  const socialInfo = [
    {
      icon: WhatsAppIcon,
      title: 'WhatsApp',
      details: ['(41) 99833-0446', 'Entre em contato conosco']
    },
    {
      icon: InstagramIcon,
      title: 'Instagram',
      details: ['@primeats_oficial', 'Siga nossas novidades']
    }
  ];

  return (
    <section id="contatos" className="contact">
      <div className="contact-container">
        {/* Header */}
        <div className="contact-header">
          <h2 className="contact-title">Entre em Contato</h2>
          <p className="contact-subtitle">
            Pronto para elevar o sabor dos seus produtos? Fale conosco e descubra 
            como podemos ser seu parceiro de sucesso.
          </p>
        </div>

        <div className="contact-content">
          {/* Informações de Contato */}
          <div className="contact-info">
            <h3 className="info-title">Informações de Contato</h3>
            <div className="info-grid">
              {contactInfo.map((info, index) => (
                <div 
                  key={index} 
                  className="info-card"
                  onClick={() => handleContactClick(info.type, info.value)}
                >
                  <div className="info-icon">
                    {info.isImage ? (
                      <img src={info.icon} alt={info.title} className="contact-icon-img" />
                    ) : (
                      info.icon
                    )}
                  </div>
                  <div className="info-content">
                    <h4 className="info-card-title">{info.title}</h4>
                    {info.details.map((detail, idx) => (
                      <p key={idx} className="info-detail">{detail}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Redes Sociais */}
          <div className="social-info">
            <h3 className="info-title">Redes Sociais</h3>
            <div className="social-grid">
              {socialInfo.map((info, index) => (
                <div 
                  key={index} 
                  className="social-card"
                  onClick={() => {
                    if (info.title === 'Instagram') {
                      window.open('https://www.instagram.com/primeatsfoods/', '_blank');
                    } else if (info.title === 'WhatsApp') {
                      window.open('https://wa.me/5541998330446', '_blank');
                    }
                  }}
                  style={{ cursor: info.title === 'Instagram' || info.title === 'WhatsApp' ? 'pointer' : 'default' }}
                >
                  <div className="info-icon">
                    <img src={info.icon} alt={info.title} className="social-icon-img" />
                  </div>
                  <div className="info-content">
                    <h4 className="info-card-title">{info.title}</h4>
                    {info.details.map((detail, idx) => (
                      <p key={idx} className="info-detail">{detail}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Contact;